import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { NewDeviceStateI } from '../types/newDevice';

const initNewDeviceState: NewDeviceStateI = {
    name: 'RFGB-40/',
    type: 'controller',
    tech: 'wireless',
    material: 'glass',
    icons: 4,
    round: false,
    colors: ['black', 'white'],
    colorsShortcut: ['B', 'W'],
    selectedColor: null,
    className: 'glass-40',
    previewImage: 'glass-40',
    renderImage: 'glass'
}

const newDeviceSlice = createSlice({
  name: 'newDevice',
  initialState: initNewDeviceState,
  reducers: {
    setDevice: (state, action: PayloadAction<NewDeviceStateI>) => {
        state.name = action.payload.name;
        state.tech = action.payload.tech;
        state.material = action.payload.material;
        state.icons = action.payload.icons;
        state.round = action.payload.round;
        state.colors = action.payload.colors;
        state.colorsShortcut = action.payload.colorsShortcut;
        state.selectedColor = action.payload.selectedColor || state.selectedColor;
        state.className = action.payload.className;
        state.previewImage = action.payload.previewImage;
        state.renderImage = action.payload.renderImage;
    },
    setDeviceMaterial: (state, action: PayloadAction<string>) => {
        state.material = action.payload;
    },
    setDeviceShape: (state, action: PayloadAction<boolean>) => {
        state.round = action.payload;
    },
    setNumberOfButtons: (state, action: PayloadAction<number>) => {
        state.icons = action.payload;
    },
    setDeviceColor: (state, action: PayloadAction<string>) => {
        state.selectedColor = action.payload;
    },
    setDeviceColors: (state, action: PayloadAction<string[]>) => {
        state.colors = action.payload;
    },
    setDeviceColorsShortcut: (state, action: PayloadAction<string[]>) => {
        state.colorsShortcut = action.payload;
    },
    setDeviceName: (state, action: PayloadAction<string>) => {
        state.name = action.payload;
    },
    setDefaultDevice: (state) => {
        state.name = initNewDeviceState.name;
        state.tech = initNewDeviceState.tech;
        state.material = initNewDeviceState.material;
        state.icons = initNewDeviceState.icons;
        state.round = initNewDeviceState.round;
        state.colors = initNewDeviceState.colors;
        state.colorsShortcut = initNewDeviceState.colorsShortcut;
        state.selectedColor = initNewDeviceState.selectedColor;
        state.className = initNewDeviceState.className;
        state.previewImage = initNewDeviceState.previewImage;
        state.renderImage = initNewDeviceState.renderImage;
    }
  }
});

export const { 
    setDevice,
    setDeviceMaterial,
    setDeviceShape,
    setNumberOfButtons,
    setDeviceColor,
    setDeviceColors,
    setDeviceColorsShortcut,
    setDeviceName,
    setDefaultDevice
} = newDeviceSlice.actions;

export default newDeviceSlice.reducer;